// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"CreateQuestionPage_btn-wrapper__gkqep","question-botton":"CreateQuestionPage_question-botton__-zjfO"};